import { ReactNode } from 'react';
import { Box, Toolbar } from '@mui/material';
import { ReadSpeakerReader } from 'src/components/ScreenReaders';
import { useSiteContext } from 'src/store';
import Footer from '../../Footer';
import Header from '../../Header';
import BaseLayout from '../BaseLayout';

type Props = {
  children: ReactNode;
  pageTitle?: string;
};

export const RootWidgetLayout = (props: Props) => {
  const { children, pageTitle } = props;
  const readSpeakerId = 'readSpeakerReadMe';
  const isEmbeddedMode = useSiteContext().siteMode === 'embedded';
  return (
    <BaseLayout pageTitle={pageTitle}>
      <>
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {!isEmbeddedMode && (
            <>
              <Header />
              <Toolbar />
            </>
          )}
          <ReadSpeakerReader readId={readSpeakerId} />
          <Box component="main" id="main-content">
            <Box component="div" id={readSpeakerId}>
              {children}
            </Box>
          </Box>
          {!isEmbeddedMode && <Footer />}
        </div>
      </>
    </BaseLayout>
  );
};

export default RootWidgetLayout;
